
import React from 'react';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { useState, useEffect } from 'react';

const FloatingActionButton: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is authenticated
    const checkAuth = async () => {
      const { data } = await supabase.auth.getSession();
      setIsAuthenticated(!!data.session);
    };

    checkAuth();

    // Set up listener for auth changes
    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      setIsAuthenticated(!!session);
    });

    return () => {
      authListener.subscription.unsubscribe();
    };
  }, []);

  const handleClick = () => {
    // Navigate to create content page or open modal
    console.log('Floating button clicked');
  };

  // Only render button if user is authenticated
  if (!isAuthenticated) return null;

  return (
    <div className="fixed bottom-20 right-6 z-50">
      <Button 
        size="icon" 
        variant="neon-purple" 
        className="h-12 w-12 rounded-full shadow-lg shadow-neon-purple/20 hover:shadow-neon-purple/40 transition-all duration-300"
        onClick={handleClick}
      >
        <Plus className="h-5 w-5" />
      </Button>
    </div>
  );
};

export default FloatingActionButton;
